/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Paypal_EnabledInputs */

const en_admin_settings_fields_paypal_enabled = /** @type {(inputs: Admin_Settings_Fields_Paypal_EnabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable PayPal`)
};

/**
* | output |
* | --- |
* | "Enable PayPal" |
*
* @param {Admin_Settings_Fields_Paypal_EnabledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_paypal_enabled = /** @type {((inputs?: Admin_Settings_Fields_Paypal_EnabledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Paypal_EnabledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_settings_fields_paypal_enabled(inputs)
});
export { admin_settings_fields_paypal_enabled as "admin.settings.fields.paypal_enabled" }